module.exports = __webpack_public_path__ + "img/event_carpet_expoluxe_9654_dark_blue.b6ab0609.jpg";